<template>
  <div style="padding-top: 30px;">
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="500"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column
        field="driverName"
        title="实际承运人姓名"
        min-width="130"
        sortable
      />
      <vxe-table-column
        field="driverPhone"
        title="电话"
        min-width="130"
        sortable
      />
      <vxe-table-column
        field="driverType"
        :formatter="formatterDriverType"
        title="实际承运人/车队"
        min-width="130"
        sortable
      />
      <vxe-table-column
        field="vehicleLicenseNumber"
        title="车牌号"
        min-width="130"
        sortable
      />
      <vxe-table-column
        field="classificationCode"
        title="车型"
        :formatter="formatterVehicleClassification"
        min-width="130"
        sortable
      />
      <vxe-table-column
        field="bidCount"
        title="车数"
        min-width="130"
        sortable
      />
      <vxe-table-column
        field="bidWeight"
        title="每车承运数量"
        min-width="140"
        sortable
      />
      <vxe-table-column
        field="coalUnitName"
        title="单位(数量)"
        min-width="130"
        sortable
      />
      <vxe-table-column
        field="bidPrice"
        title="单价"
        min-width="130"
        sortable
      />
      <vxe-table-column
        field="isTrunkName"
        title="单位(价格)"
        min-width="130"
        sortable
      />
      <vxe-table-column
        field="arrivalTime"
        title="预计到达时间"
        min-width="200"
        sortable
      />
      <vxe-table-column title="操作" min-width="50" fixed="right">
        <template slot-scope="scope">
          <el-tooltip effect="dark" content="承运" placement="top">
            <vxe-button
              v-if="scope.row.isDeal == 0"
              type="text"
              @click="handleClick(scope.row.code, scope.row.partyCode)"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { driverBidList, selectBid } from "@/api/orderform";
import { getListDict } from "@/api/commonApi";

export default {
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      isDeal: "",
      listQuery: {
        page: 1,
        pageSize: 20,
        total: 0,
        mainOrderCode: ""
      },
      // Pagingconf: [],
      vehicleClassificationList: [],
      offerdata: {
        code: "",
        pushTarget: ""
      }
    };
  },
  created() {
    getListDict({
      types: "vehicleClassification"
    }).then(response => {
      this.vehicleClassificationList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
    });
  },
  methods: {
    // 排序
    sortList({ column, property, order }) {
      if (order) {
        this.listQuery.sortField = property;
        this.listQuery.sortType = order;
      } else {
        this.listQuery.sortField = "";
      }
      this.Getdistr(this.listQuery.mainOrderCode);
    },
    async Getdistr(code) {
      if (code) {
        this.listQuery.mainOrderCode = code;
      }
      let response = await driverBidList(this.listQuery);
      this.tableData = response.data.records;
      this.isDeal = response.data.isDeal;
      this.listQuery.total = response.data.total;
      // response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
    },
    handleClick(c, d) {
      this.offerdata.code = c;
      this.offerdata.pushTarget = d;
      this.$confirm("是否选择承运?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          selectBid(this.offerdata).then(response => {
            this.$message({
              type: "success",
              message: response.msg
            });
            this.Getdistr(this.listQuery.mainOrderCode);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.page = currentPage;
      this.listQuery.pageSize = pageSize;
      this.Getdistr();
    },
    // 翻译车型
    formatterVehicleClassification({ cellValue }) {
      const item = this.vehicleClassificationList.find(
        item => item.code === cellValue
      );
      return item ? item.name : "";
    },
    formatterDriverType({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "实际承运人";
        case 1:
          return "车队";
        default:
          break;
      }
    }
  }
};
</script>
